// src/socket.js
import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_GLOBAL_URL; // Replace with your server URL

const socket = io(SOCKET_URL, {
  withCredentials: true,
  transports: ["websocket"],
});

export default socket;
